
          import { defineNuxtPlugin } from "#imports";

          export default defineNuxtPlugin({
            name: 'sentry-client-config',
            async setup() {
              await import("/home/runner/work/pennywhales-tma/pennywhales-tma/sentry.client.config.ts")
            }
          });